const toastr = require('toastr')
import Toastr from '@/components/Toastr'

Toastr.install = (app) => {
    app.config.globalProperties.$toastr = toastr
}

export default Toastr